module.exports = __webpack_public_path__ + "static/media/page-not-found.a64b661d.png";